import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  getSpecificOffer: () => {
    return axiosInstance.get(API_URL.SPECIFIC_OFFER);
  },

  getGeneralOffer: () => {
    return axiosInstance.get(API_URL.GENERAL_OFFER);
  },
};
